export default "__VITE_ASSET__6cbd679f__"